<p-dialog [visible]="showDialog$ | async" [header]="(isOnBehalfOfMode$ | async) ? 'Create Call': 'Contact us'" showEffect="fade" [modal]="true" [closable]="false"
  appendTo="body" [style]="{width: '50vw'}">
  <form *ngIf="form$ | async as form" [formGroup]="form">

    <ng-container *ngIf="displayAutocompletes$ | async; then onBehalfOfView else inPersonView"></ng-container>

    <ng-template #onBehalfOfView>
      <div>
        <div>
          <label>Caller</label>
        </div>
        <p-autoComplete class="mojo-form-control" minLength="0" completeOnFocus="true" formControlName="Entity" [group]="true"
          [forceSelection]="true" [suggestions]="callerSuggestions$ | async" dataKey="Key" field="Name" appendTo="body"
          (onKeyUp)="deselectCaller()"
          (onSelect)="handleCallerSelected($event)" (completeMethod)="callerAutoCompleteChange($event)">
          <ng-template let-group pTemplate="group">
            <div class="dropdown-group-label">
              {{group.label}}
            </div>
          </ng-template>
        </p-autoComplete>
      </div>
      <div>
        <div>
          <label>Unit</label>
        </div>
        <p-autoComplete class="mojo-form-control" minLength="0" completeOnFocus="true" formControlName="Unit"
          [forceSelection]="true" [suggestions]="unitSuggestions$ | async" dataKey="Key" field="Name" appendTo="body"
          (onKeyUp)="deselectUnit()"
          (onSelect)="handleUnitSelected($event)" (completeMethod)="unitAutoCompleteChange($event)"></p-autoComplete>
      </div>
    </ng-template>

    <ng-template #inPersonView>
      <div>
        <div>
          <label>Unit</label>
        </div>
        <p-dropdown [options]="units$ | async" formControlName="Unit" optionLabel="Name" appendTo="body"
          optionValue="Key"></p-dropdown>
      </div>
    </ng-template>

    <div>
      <div>
        <label>Subject</label>
      </div>
      <p-dropdown [options]="subjects$ | async" formControlName="Subject" optionLabel="Subject" appendTo="body"
        optionValue="Uri"></p-dropdown>
    </div>

    <div>
      <div>
        <label>Message*</label>
      </div>
      <textarea formControlName="Message" rows="5" cols="30" pInputTextarea></textarea>
      <div *ngIf="form.controls.Message?.errors && (form.controls.Message?.dirty || form.controls.Message?.touched)"
        class="alert-danger">
        <section>
          <p *ngIf="form.controls.Message?.errors['required']">This is required</p>
        </section>
      </div>
    </div>
    <div>
      <div>
        <label>Reply Email*</label>
      </div>
      <input formControlName="EmailAddress" type="text" pInputText />
      <div
        *ngIf="form.controls.EmailAddress?.errors && (form.controls.EmailAddress?.dirty || form.controls.EmailAddress?.touched)"
        class="alert-danger">
        <section>
          <p *ngIf="form.controls.EmailAddress?.errors['required']">This is required</p>
          <p *ngIf="form.controls.EmailAddress?.errors['email']">This is not a valid email</p>
        </section>
      </div>
    </div>
  </form>
  <p-footer>
    <div class="btn-group" role="group" aria-label="..." [style]="{width: '100%'}">
      <p-fileUpload #fileUpload chooseLabel="Upload Images" [showUploadButton]="false" [showCancelButton]="false"
        multiple="multiple" accept="image/*">
      </p-fileUpload>
      <button type="button" [disabled]="!(canSubmit$ | async)" pButton icon="fa-fw fa fa-check" (click)="send()"
        [label]="(isOnBehalfOfMode$ | async ) ? 'Save / Send Notifications' : 'Send'"></button>
      <button type="button" [disabled]="!(canCancel$ | async)" pButton icon="fa-fw fa fa-close" (click)="cancel()"
        label="Cancel"></button>
    </div>
  </p-footer>
</p-dialog>
